import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { icons, IconSanitizerService } from 'ngx-lib';

export interface CustomCellIconAndContentParams extends ICellRendererParams {
    iconName?: keyof typeof icons;
    getContent?: (params: ICellRendererParams) => string;
}

function encodeForHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

@Component({
    selector: 'app-custom-cell-icon-and-content',
    templateUrl: './custom-cell-icon-and-content.component.html',
    styleUrls: ['./custom-cell-icon-and-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class CustomCellIconAndContentComponent implements ICellRendererAngularComp {
    icon = signal<SafeHtml | null>(null);
    content = signal('');
    params!: ICellRendererParams;

    private readonly iconSanitizer = inject(IconSanitizerService);

    agInit(params: ICellRendererParams): void {
        this.params = params;
        const config = (params.colDef?.cellRendererParams || {}) as CustomCellIconAndContentParams;
        const iconName = config.iconName;
        this.icon.set(iconName ? this.iconSanitizer.getIcon(iconName) : null);
        const raw = config.getContent?.(params) ?? '';
        this.content.set(encodeForHtml(raw));
    }

    refresh(): boolean {
        return false;
    }
}
